/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Required_FieldInputs */

const vi_einvoice_credential_required_field = /** @type {(inputs: Einvoice_Credential_Required_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập tài khoản và mật khẩu MISA.`)
};

/**

* @param {Einvoice_Credential_Required_FieldInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_required_field = /** @type {((inputs?: Einvoice_Credential_Required_FieldInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Required_FieldInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_required_field(inputs)
});